<template>
    <a-table :dataSource="datasource" :columns="columns" :pagination="pageData" @change="tableChangeHandle">
        <template #bodyCell="{ column,text, record }">
            <template v-if="column.key === 'status'">
                <a-tag v-if="record.status === 1" title="Enable" color="#EBF7F2" style="color:#1BAB6F">Enable</a-tag>
                <a-tag v-else-if="record.status === 0" title="Disable" color="#FAFAFA" style="color:#999999">Disable</a-tag>
            </template>
            <template v-else-if="column.key === 'action'">
                <div v-if="record.status === 1">
                    <a href="javascript:void(0);" @click="changeStatus(record)">Disable</a>
                </div>
                <div v-else-if="record.status === 0">
                    <a href="javascript:void(0);" @click="changeStatus(record)">Enable</a>
                </div>
            </template>
            <template v-else-if="column.key === 'origincode'">
                <div v-if="text === null">-</div>
                <div v-else>{{ text }}</div>
            </template>
            <template v-else-if="column.key === 'origindesc'">
                <div v-if="text === null">-</div>
                <div v-else>{{ text }}</div>
            </template>
            <template v-else-if="column.key === 'replacecode'">
                <div v-if="text === null">-</div>
                <div v-else>{{ text }}</div>
            </template>
            <template v-else-if="column.key === 'replacedesc'">
                <div v-if="text === null">-</div>
                <div v-else>{{ text }}</div>
            </template>
        </template>
    </a-table>
</template>
<script lang="ts">
import { defineComponent, nextTick, onMounted, onUnmounted, reactive, ref } from 'vue'
import Api from '@/api/Api'
import { getPgaColor } from "@/common/tool"
import { message } from 'ant-design-vue';

export default defineComponent({
    name : 'RuleLibs',
    components:{

    },
    
    setup(props, {emit}) {
        const datasource : any  = ref([])
        const columns  = [
            {title: "Origin HTS Code", key : "origincode", dataIndex : "originHtsCode" },
            {title: "Origin Shipment Description", key : "origindesc", dataIndex : "originDescription"},
            {title: "Replace HTS Code", key : "replacecode", dataIndex : "replaceHtsCode"},
            {title: "Replace Shipment Description", key : "replacedesc", dataIndex : "replaceDescription"},
            {title: "Status", key : "status", dataIndex : "status",width : "150px"},
            {title: "Update Time", key: "updateTime", dataIndex : "updateTime"},
            {title: "Actions", key : "action", width : "150px"}
        ]
        const pageData = reactive({
            current : 1,
            pageSize : 10,
            total : 0,
            showSizeChanger : false,
            showQuickJumper : false,
            showLessItems : false,
        })
        let search_str = ref("")

        onMounted(() =>{
            nextTick(()=>{
                getData()
            })
        })

        onUnmounted(()=>{
            console.log("unmounted")
            search_str.value = ""
        })

        const getData = async() =>{
            let params : any = {
                pageSize : pageData.pageSize,
                pageNum : pageData.current,
                orderByColumn : "createTime",
                isAsc: "desc"
            }
            if( search_str.value !=""){
                params.searchKeyword = search_str.value
            }
            emit("load_event", true)
            datasource.value = []
            let data = await Api.getRuleLibs(params)
            emit("load_event", false)
            console.log(data)
            
            if( data && data?.code === 200){
                pageData.total = data?.total
                datasource.value = data?.rows
            }else{
                message.error("Get Data Fail",2)
            }
            
        }

        const tableChangeHandle = (pagination : any) =>{
            if( pageData.current === pagination.current && pageData.pageSize === pagination.pageSize){
                return
            }else{
                pageData.total = 0
                pageData.current = pagination.current
                pageData.pageSize = pagination.pageSize
                getData()
            }
        }

        const getColor = (key : string ) =>{
            return getPgaColor(key)
        }

        const search = async(key : string) =>{
            search_str.value = key
            pageData.current = 1
            pageData.total = 0
            getData()
        }

        const changeStatus = async( item : any ) =>{
            console.log(item)
            let params : any = {
                ruleId : item.ruleId,
            }
            if( item.status === 1){
                params.ruleStatus = 0
            }else{
                params.ruleStatus = 1
            }
            show_loading(true)
            let data = await Api.updateRuleStatus(params)
            if( data && data?.code === 200) {
                message.success("Operate Succ",2)
                getData()
            }else{
                show_loading(false)
                message.error("Operate Fail",2)
            }
        }

        const show_loading = (b : boolean) =>{
            emit("load_event", b)
        }

        const getDateStr = (time: number) =>{
            let date : Date = new Date(time)
            let result = ""
            result = date.getUTCFullYear() + "-" + date.getUTCMonth() + "-" + date.getUTCDate() + " " + date.getUTCHours() + ":" + date.getUTCMinutes() + ":" + date.getUTCSeconds()
            return result
        }

        return {
            datasource,
            columns,
            pageData,
            tableChangeHandle,
            getColor,
            changeStatus,
            search
        }
    },
})
</script>